import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { FileUrlPipeModule } from 'src/app/pipes/file-url-pipe/file-url-pipe.module';
import { AudioPlaylistPlayerModule } from '../audio-playlist-player/audio-playlist-player.module';
import { QueuePeriodicAnnouncementListComponent } from './queue-periodic-announcement-list.component';

@NgModule({
   declarations: [QueuePeriodicAnnouncementListComponent],
   exports: [QueuePeriodicAnnouncementListComponent],
   imports: [
      DragDropModule,
      FormsModule,
      CommonModule,
      ReactiveFormsModule,
      MatIconModule,
      MatTooltipModule,
      MatButtonModule,
      FileUrlPipeModule,
      MatCheckboxModule,
      MatMenuModule,
      LcsLoadingOverlayModule,
      AudioPlaylistPlayerModule,
      MatProgressSpinnerModule,
      MatFormFieldModule,
   ],
})
export class QueuePeriodicAnnouncementListModule {}
